import { Comment } from '../../types'
import { DenormalizedComment } from './dtoParsers'

export const setTimestampToNow = (comment: Comment | DenormalizedComment) => {
  return { ...comment, timestamp: Date.now() }
}
